import { getRecurrentSuccess, hasError, startLoading } from 'redux/slices/recurrent';
import { ApiClients } from '../../utils/axios';
import { dispatch } from '../store';

const { axiosBase } = ApiClients;

export function getRecurrentThunk() {
  return async () => {
    dispatch(startLoading());
    try {
      const response = await axiosBase.get<{ data: { recurrent: boolean } }>('g-recurrent');

      dispatch(getRecurrentSuccess(response.data.data.recurrent));

      return response.data.data;
    } catch (error) {
      dispatch(hasError(error));

      throw new Error(error);
    }
  };
}

export function editRecurrentThunk(params: { recurrent: boolean }) {
  return async () => {
    dispatch(startLoading());
    try {
      await axiosBase.put('g-recurrent', {
        ...params,
      });

      return true;
    } catch (error) {
      dispatch(hasError(error));

      throw new Error(error);
    }
  };
}
